import './App.css';
import {useState,useEffect} from 'react'
import Modal from "react-modal";
import classNames from 'classnames';
import BCHJS from "@psf/bch-js";
import Flip from "./Flip";
import TextModal from "./TextModal";
import QRCode from "qrcode.react";
import contractParams from './contractParams.json';
const { ElectrumClient, ElectrumTransport } = require('electrum-cash');

let bchjs = new BCHJS();

function App() {
  const [modalIsOpen, setmodalIsOpen] = useState(false);
  const firstStateContract = {
    state: 0,
    txid: contractParams.txid,
    address: contractParams.address,
    lastbalance: contractParams.initialBalance,
    locktime: contractParams.locktime,
    pkhrecipient: contractParams.pkhFeeAddress,
    expired: false
  }
  const initialVout = contractParams.initialVout;
  const [lastStateContract, setLastStateContract] = useState(firstStateContract);
  const [contractHistory, setContractHistory] = useState([firstStateContract]);
  const [BCHprice, setBCHprice] = useState(0);
  const [blockHeight, setBlockHeight] = useState();
  const [fetchSucces, setFetchSucces] = useState(0);
  const [readLocalStorage, setReadLocalStorage] = useState(false);
  const [animate, setAnimate] = useState(true);
  const [electrum, setElectrum] = useState();

  const serverAddress = "bitcoincash:qphsnj7nc8u2xq36fdceclpsp3r42t7wqcjdna22wg";

  Modal.setAppElement('#root')

  useEffect(() =>{
    const connect = async () => {
      const newElectrum = new ElectrumClient(
        'Electrum client example',
        '1.4.1', 'bch.imaginary.cash',
        ElectrumTransport.WSS.Port,
        ElectrumTransport.WSS.Scheme
      );
      await newElectrum.connect();
      setElectrum(newElectrum);
    }
    connect()
  },[])
  
  useEffect(() =>{
    const readLocalStorage = () => {
      // Convert the string back to the lastStateContract object
      const lastStateContract = JSON.parse(localStorage.getItem("lastStateContract"));
      const contractHistory = JSON.parse(localStorage.getItem("contractHistory"));
      // If the local storage is not null
      if (lastStateContract !== null && contractHistory !== null) {
        // Write the contractHistory & lastStateContract to state, dot notation for rerender
        setContractHistory([...contractHistory]);
        setLastStateContract(lastStateContract);
      }
      setReadLocalStorage(true);
    };
    const fetchPrice = async () => {
      try {
        const BCHprice = await bchjs.Price.getBchUsd();
        setBCHprice(BCHprice)
      } catch (err) {
        console.log(err);
      }};
    readLocalStorage();
    fetchPrice();
  },[])

  useEffect(() =>{
    const subscribeBlockheight = async () => {
      if(!electrum) return;
      // Set up a callback function to handle new blocks.
      const handleNewBlocks = (data) => {setBlockHeight(data.height); console.log(data)}
      // Set up a subscription for new block headers and handle events with our callback function.
      try{
        await electrum.subscribe(handleNewBlocks, 'blockchain.headers.subscribe');
        setFetchSucces(1);
      } catch(e){
        console.log(e);
        setFetchSucces(0)
      }
    }
    subscribeBlockheight();
  },[electrum])

  useEffect(() => {
    const writeToLocalStorage = () => {
      // write the lastStateContract object & contractHistory array to local storage as a string
      localStorage.setItem("lastStateContract", JSON.stringify(lastStateContract));
      localStorage.setItem("contractHistory", JSON.stringify(contractHistory));
    };
    // Write the lastStateContract to localStorage each time it changes
    writeToLocalStorage();
  }, [contractHistory,lastStateContract]);

  useEffect(() =>{
    if(!readLocalStorage)return;
    
    const checkTxsContractAddr = async () => {
      if(lastStateContract.expired  || !electrum) return;

      // Request the full transaction history for an address.
      console.log(lastStateContract.address)
      const txHistory = await electrum.request('blockchain.address.get_history', lastStateContract.address);

      // Print out the transaction history.
      console.log(txHistory);

      for (let tx of txHistory) {
        const currentTxId = tx.tx_hash;
        if(currentTxId === lastStateContract.txid){continue}
        // Request the full transaction details for the transaction ID.
        let transactionDetails;
        try{
          transactionDetails = await electrum.request('blockchain.transaction.get', tx.tx_hash, true);
          setFetchSucces(1);
        }catch(e){
          console.log(e);
          setFetchSucces(0);
        }

        // Print out the transaction details.
        console.log(transactionDetails);

        transactionDetails.vin.forEach(async (input) => {
          let contractVout = 0;
          if(lastStateContract.state === 0) contractVout = initialVout;
          const voutInput = input.vout;
          if(input.txid === lastStateContract.txid && voutInput === contractVout){
            console.log('found tx spending the contract utxo!')
            const newBalance =  transactionDetails.vout[0].value * 100000000;
            const newLocktime = transactionDetails.locktime;
            const newContractAddress = transactionDetails.vout[0].scriptPubKey.addresses[0];
            let unixTimestamp = transactionDetails.time
            if(unixTimestamp===0) unixTimestamp=Date.now();
            const txtime = new Date(unixTimestamp* 1000).toUTCString();
            if(newContractAddress[12]==='q'){
              const expiredContract = {...lastStateContract, expired:true, txtime};
              setLastStateContract(expiredContract);
              setContractHistory(contractHistory => {
              const newContractHistory = contractHistory.slice(1);
                return [expiredContract, ...newContractHistory]
              });
              console.log(expiredContract);
                    
              return;
            }

            const redeemScriptHex = input.scriptSig.hex;
            const pkhRecipientHex = redeemScriptHex.slice(11 * 2, 31 * 2);
            // pkhNewRecipient is 3rd argument of refresh cunction in contract, arguments are added in reverse order
            // first push 8bytes with the 8 bytes amountChange, byte bool hasChangeOutput and push 20byes pkh
            // (so 1+8+1+1) and then the actual 20 bytes of the pkhNewRecipient so starts at index 11
            const newStateContract = {
              state: lastStateContract.state+1,
              txid: currentTxId,
              address: newContractAddress,
              lastbalance: newBalance,
              locktime: newLocktime,
              pkhrecipient: pkhRecipientHex,
              expired: false,
              txtime
            };
            setContractHistory([newStateContract, ...contractHistory]);
            setLastStateContract(newStateContract);
          }
        })
      }
    }
    checkTxsContractAddr();
  },[readLocalStorage,electrum,lastStateContract])

  let blocksLeft =lastStateContract.locktime+contractParams.period-blockHeight;
  const toBCH = (satAmount) =>  (satAmount/ 100000000)
  let refreshCost = toBCH(contractParams.increment + 2000)
  let payoutAddr
  if(lastStateContract.pkhrecipient){payoutAddr = bchjs.Address.hash160ToCash(lastStateContract.pkhrecipient)}
  
  let startdate
  if(contractHistory.length-1>0){
    let txtimeUTC = contractHistory[contractHistory.length-2].txtime;
    startdate = txtimeUTC.substring(0, 16);
  }

  return (
    <div className="App">
      <div className="body">
      <header>
        <span className="title">RefreshTimer.cash - a BCH smart contract game</span>
      </header>
      
      <Modal isOpen={modalIsOpen} onRequestClose={() => setmodalIsOpen(false)} style={{overlay: {zIndex:"2"},content:{textAlign:"left", padding: "25px 50px", inset: "50px"}}}>
      <button onClick={() => setmodalIsOpen(false)} className="clickable topRight">close</button>
        <h2>Things to note</h2>
        <TextModal BCHprice={BCHprice}/>
      </Modal>

      <main>
      <section className="columnL">
        <h2>Contract History</h2>
        <p>You can follow the whole contract history on-chain</p>
        <div className="divTable">
        <table style={{width:'100%'}}>
          <thead>
              <tr>
                <th>State</th>
                <th>Amount</th>
                <th>Time</th>
              </tr>
          </thead>
          <tbody>
            {contractHistory.map(({state,lastbalance,locktime,address,expired},index) => 
              (<tr key={state} style={{lineHeight:'1.8'}}>
                  <td>
                  <a target='_blanc' style={{textDecoration:'none'}} href={`https://blockchair.com/bitcoin-cash/address/${address}`}>
                    {state}
                  </a>
                </td>
                <td>{toBCH(lastbalance)+" BCH"}</td>
                <td>
                  {contractHistory[index-1]? (contractHistory[index-1].locktime-locktime + (contractHistory[index-1].locktime-locktime===1?' block':' blocks')): 
                  expired?  contractParams.period + ' blocks' :(blockHeight-locktime + (blockHeight-locktime===1?' block':' blocks')) }
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        <br/>
        {!electrum? 'connecting to electrum server':fetchSucces===0? 'fetching electrum server failed':null}
      </section>
      <section>
        <div className="h2">RefreshTimer.cash</div>
        <img alt="" className={classNames(
        {refreshlogo:true,animate: animate}
      )} src="./refresh.png"/>
        <p className="explanation"> 
          ... when the timer hits zero the last refresher wins the game!<br/>
          You can refresh the timer and set it back to {contractParams.period} blocks 
          (~{contractParams.period<6?`${contractParams.period*10}min` :`${+(contractParams.period/6).toFixed(2)}h`}). <br/>
          This sets your address as payoutaddress in the smart contract. <br/>
          Then you earn the contract balance if the timer expires!
        </p>
        <button onClick={() => setmodalIsOpen(true)} className="clickable">{"-> click to read details"}</button>
        <br/>
          {!electrum? (<h2>connecting to electrum server</h2>):
          lastStateContract.expired===false?
          (<div>
            <h2 style={{textDecoration: "underline"}}>Contract ongoing</h2>
          <div className="box">
            <br />
            <h3>Contract payout address</h3>
            <div className="payoutAddress">{payoutAddr}</div>
            <h2>Wins {" "}
                  {+(toBCH(lastStateContract.lastbalance*0.9)-0.00001).toFixed(6)} BCH (
                  {((toBCH(lastStateContract.lastbalance*0.9)-0.00001)*BCHprice).toFixed(2)}
                  $)
            </h2>
            <div style={{margin:'auto'}}>
              <span className='blocks'>{'in'}</span>
              <Flip value={blocksLeft} /> 
              <span className='blocks'>{blocksLeft===1?'block':'blocks'}</span>
            </div>
            <div>
              <br/>
              <span> {'-> contract balance minus 10% contract fee'}</span>
            </div>
            </div></div>)
            :(<div>
              <h2 style={{textDecoration: "underline"}}>Contract ended</h2>
              <div className="box">
              <br />
              <h3>Address last refresh</h3>
              <div className="payoutAddress">{payoutAddr}</div>
              <h3>
                  {"Won "}
                  {+(toBCH(lastStateContract.lastbalance*0.9)-0.00001).toFixed(6)} BCH (
                  {((toBCH(lastStateContract.lastbalance*0.9)-0.00001)*BCHprice).toFixed(2)}
                  $)
                </h3>
                <span> {'-> contract balance minus 10% contract fee'}</span>
                <h3>Ended {lastStateContract.txtime}</h3>
                
                <a href={`https://blockchair.com/bitcoin-cash/address/${lastStateContract.address}`} target="_blanc">
                  link payout transaction
                </a>
              </div>
            </div>)
          }
        </section>
        {
          lastStateContract.expired===false?(
            <section className="columnR">
              <h2>How to refresh</h2>
              <p>
                To enter the game you just have to send the requested amount of BCH to the QR code.
                <br/><br/>
                {`It costs ${toBCH(contractParams.increment)} BCH to refresh the timer of the contract plus 2000 sats in minerfees totaling ${(BCHprice*toBCH(contractParams.increment+2000)).toFixed(2)}$.`}
                <br/><br/>
                The server will interact with the smart contract on your behalf and add your address to the smart contract as payout address.
              </p>
              {serverAddress!==undefined? (<><QRCode
                id="QR"
                value={`${serverAddress}?amount=${refreshCost}`}
                size={200}
                renderAs="svg"
                style={{margin:"10px"}}
              />
              <p style={{overflowWrap:'anywhere',margin:"0px"}}>{`${serverAddress}?amount=${refreshCost}`}</p>
              </>):<><br/><br/><p>could not fetch server address</p></>}
            </section>)
          :(<section className="columnR">
              <h2>Game stats</h2>
              <p style={{overflowWrap:'anywhere',margin:"0px"}}>
                First iteration of the game has ended. <br/><br/> 
                The game began {startdate} with a start balance of
                {` ${toBCH(contractParams.initialBalance)}BCH (${(toBCH(contractParams.initialBalance)*BCHprice).toFixed(2)}$) `}
                which grew {`${+(100*(lastStateContract.lastbalance-contractParams.initialBalance)/contractParams.initialBalance).toFixed(2)}% over its lifetime.`}
                <br/><br/>
                {`The refresh function of the contract was used ${lastStateContract.state} times before there was a ${contractParams.period} block period where it was uninvoked.`}
                <br/><br/>
                {`10% of the contract balance was paid out as contract fee so minus the initial balance this means the profit of running this smart contract was ${toBCH(lastStateContract.lastbalance*0.1-contractParams.initialBalance)}BCH`}
                <br/><br/><br/>
                Server address used last game to forward the transactions from the QR code to the smart contract: <br/>
                {serverAddress!==undefined? serverAddress :(<><br/><br/>could not fetch server address</>)}
              </p>
            </section>
          )
        }
      </main>
      </div>
      <footer>
      <a
            href="https://github.com/mr-zwets/RefreshContract/"
            target="_blanc" style={{textDecoration:"none",color:"black"}}
          >
          <p>
          Check contract code
        </p>
        </a>
        <a
          href="https://github.com/mr-zwets/RefreshContract/"
          target="_blanc"
        >
          <img alt="" className="githublogo" src="./github.png" />
        </a>
        <a
          href="https://twitter.com/refreshtimer"
          target="_blanc"
        >
          <img alt="" className="twitterlogo" src="./twitter.png" />
        </a>
      </footer>
    </div>
  );
}

export default App;
